import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';
import CredentialDateInfo from '../credential-date-info';
import GenerateQRCode from './generate-qrcode';

interface Props {
    taskDescription: string;
    onBack: (event: any) => void;
    isEdit: boolean,
    cardCode: string,
    setImage: (base64Img: string) => void,
    downloadQRCode: () => void
}

const SummaryForm: FC<Props> = ({ taskDescription, onBack, isEdit, cardCode, setImage, downloadQRCode }) => {

    const { values } = useFormikContext<any>();
    const { translate } = useLocale();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}
        tertiaryActions={<button
            className={`py-1 px-4 mr-2 rounded-full text-white bg-sidemenu-focus text-sm items-center`}
            type="button"
            onClick={() => { downloadQRCode() }}>{translate.byKey(TranslationKeys.download)}</button>}>
        <div>
            <div>
                {!isEdit ?
                    <div className="flex flex-row">
                        <div className="flex flex-col flex-1">
                            <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                        </div>
                    </div> : null
                }
                <div className="flex pt-3">
                    <div className="flex flex-col flex-1 w-50">
                        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.tagCode)}: <span className="text-sm text-black">{values.code}</span></h4>
                        <CredentialDateInfo values={values} />
                    </div>
                </div>
            </div>
            <GenerateQRCode
                cardCode={cardCode}
                setImage={setImage}
            />
        </div>
    </WizardSummaryLayout>
}

export default SummaryForm;
